import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MemberSearchFilter } from 'src/app/shared/member-search/member-search-filter.model';
import { MemberSearchService } from 'src/app/shared/member-search/member-search.service';
import { GlobalService } from 'src/app/shared/services/global.service';
import { IdentityService } from 'src/app/shared/services/identity.service';
import { MemberService } from 'src/app/shared/services/member.service';
import { TenantService } from 'src/app/tenant/tenant.service';
import { formatDate, Location } from '@angular/common';
import { MemberSearch } from 'src/app/shared/member-search/member-search.model';
import { FollowupService } from 'src/app/shared/services/followup.service';
import { GetPlannedFollowup } from 'src/app/shared/models/getPlannedFollowup.model';
import { UpdatePlannedFollowup } from 'src/app/shared/models/updateFollowup.model';
import { AuthService } from '../account/auth.service';

@Component({
    selector: 'app-my-tasks',
    templateUrl: './my-tasks.component.html',
    styleUrls: ['./my-tasks.component.scss'],
    standalone: false
})
export class MyTasksComponent implements OnInit {
  isLoading: boolean = true;
  showOnMap: boolean = false;
  clusterOnMap: boolean = false;
  plansArr: GetPlannedFollowup[] = [];
  subdomain: string = '';
  searchText: string = '';
  completingTask: boolean = false;

  constructor(
    public memberSearchService: MemberSearchService,
    private memberService: MemberService,
    private _router: Router,
    private _location: Location,
    private globalService: GlobalService,
    private tenantService: TenantService,
    private followupService: FollowupService,
    public identityService: IdentityService,
    private changeDetectorRef: ChangeDetectorRef,
    private authService: AuthService
  ) {}

  async ngOnInit(): Promise<void> {
    this.isLoading = true;
    await this.authService.autoLogin(1);
    this.ClearFilter();
    await this.loadTasks();
    this.globalService.title.push(this.globalService.screenHeader);
    this.globalService.screenHeader = this.globalService.Get('MY_TASKS');
    this.isLoading = false;
  }

  async loadTasks() {
    this.plansArr = await this.followupService.GetFollowupByAssignee(
      this.identityService.memberId
    );
    this.plansArr = this.plansArr.filter((a) => a.status == 0);

    this.memberSearchService.filter.outReachAssignee =
      this.identityService.memberId;
    this.memberSearchService.filter.outReachStatus = 0;
    

    this.memberSearchService.searchResult =
      await this.memberSearchService.AdvancedSearch(
        this.memberSearchService.filter,
        'pageNumber=0&pageSize=0', true
      );
    this.memberSearchService.memberArr =
      this.memberSearchService.memberArr.filter(
        (a) => this.plansArr.findIndex((x) => x.memberId == a.memberId) >= 0
      );
    this.populatePlans();
  }

  populatePlans() {
    this.memberSearchService.memberArr.forEach((a) => {
      var plan = this.plansArr.filter(
        (x) => x.memberId == a.memberId && x.status == 0
      )[0];
      if (plan == null) return;
      a['taskId'] = plan.id;
      a['confirmView'] = false;
      a['editView'] = false;
      a['activity'] = plan.activity;
      a['activityStr'] = plan.activityStr;
      a['planDate'] = formatDate(plan.planDate, 'yyyy-MM-dd', 'en');
      a['actualDate'] = formatDate(plan.actualDate, 'yyyy-MM-dd', 'en');
      a['assigner'] = plan.assigner;
      a['assignerComment'] = plan.assignerComment;
      a['assignee'] = plan.assignee;
      a['assigneeComment'] = plan.assigneeComment;
      a['status'] = 1;
      a['createdBy'] = plan.createdBy;
      a['creationDate'] = plan.creationDate;
      switch (plan.activityStr) {
        case 'Visit':
          a['destination'] = a.address;
          break;
        case 'Call':
        case 'Text':
          a['destination'] = a.phoneNumber;
          break;
        case 'Email':
          a['destination'] = '';
          break;
      }
    });
  }

  ClearFilter() {
    this.memberSearchService.filter = new MemberSearchFilter();
    this.memberSearchService.filter = {
      diocese: 0,
      firstName: '',
      lastName: '',
      department: 0,
      superGroup: 0,
      group: 0,
      email: '',
      phone: '',
      gender: null,
      maritalStatus: null,
      occupation: null,
      account: null,
      role: null,
      age: [], 
      grade: [],
      city: [],
      state: [],
      zip: [],
      membership: null,
      picture: null,
      category: null,
      service: null,
      attendanceStartDate: null,
      attendanceEndDate: null,
      attendanceDateRange: null,
      followupDateRange: null,
      donationDateRange: null,
      frequency: 0,
      frequencyType: null,
      donationStartDate: null,
      donationEndDate: null,
      singleDonationMode: false,
      donationStartRange: 0,
      donationEndRange: 0,
      result: 1,
      leaders: false,
      has_role: null,
      note_selection: null,
      birthdayMonth: 0,
      birthdayDay: 0,
      attendanceStatus: 0,
      outReachStatus: null,
      outReachTask: null,
      outReachStartDate: null,
      outReachEndDate: null,
      outReachAssignee: null,
      includeAccounts: 1,
      massText: false,
      tag: 0,
      extensionValues: [],
      notification: 0
    };
    this.memberSearchService.memberArr = [];
    this.globalService.memberSearchFirst = '';
    this.globalService.memberSearchLast = '';
    this.globalService.page = 1; 
  }

  GetContacts() {
    this.MaskPrimary();
    var list = this.memberSearchService.selectedMembers;
    return list;
  }

  MaskPrimary() {
    if (this.subdomain == 'demo') {
      this.memberSearchService.memberArr.forEach((a) =>
        a['primary'] != null
          ? (a['primary'] =
              a['primary'].split(' ')[0] +
              ' ' +
              a['primary'].split(' ')[1][0] +
              'XXXXXXXXX')
          : ''
      );
    }
  }

  goFeatures() {
    this.globalService.clearCurCache = false; 
    this._router.navigate(['/home']);
  }

  goHome() {
    if (this.showOnMap == true || this.clusterOnMap == true) {
      this.showOnMap = false;
      this.clusterOnMap = false;
      return;
    }
    this.InitializeMemberSearch();
    // this.globalService.isBack = true;
    this.globalService.clearCurCache = false;
    this._location.back();
  }

  InitializeMemberSearch() {
    this.memberSearchService.memberArr = [];
    this.memberSearchService.keepSelected = false;
    this.memberSearchService.filter = null;
    this.memberSearchService.age = '';
    this.memberSearchService.grade = '';
    this.memberSearchService.city = '';
    this.memberSearchService.state = '';
    this.memberSearchService.zip = '';
    this.globalService.memberSearchFirst = '';
    this.globalService.memberSearchLast = '';
    this.InitializeFunctionExpansion();
  }

  InitializeFunctionExpansion() {
    this.memberSearchService.memberArr.forEach((a) => {
      a['expandFunctions'] = false;
      a['toolsHelp'] = false;      
      a['expanded'] = false;
    });
  }

  confirmAction(event) {
    if (event.type == event.user.activityStr || event.type == 'ALL') {
      event.user['confirmView'] = true;
      event.user['editView'] = false;
    }
  }

  async DefaultTask(user: MemberSearch) {
    let currentFollowup: GetPlannedFollowup = this.plansArr.filter(
      (x) => x.memberId == user.memberId
    )[0];
    let newRec: UpdatePlannedFollowup = new UpdatePlannedFollowup();
    newRec.id = currentFollowup.id;
    newRec.memberId = currentFollowup.memberId;
    newRec.activity = currentFollowup.activity;
    newRec.planDate = currentFollowup.planDate;
    newRec.actualDate = new Date();
    newRec.status = 1;
    newRec.assigner = currentFollowup.assigner;
    newRec.assignerComment = currentFollowup.assignerComment;
    newRec.assignee = this.identityService.memberId;
    newRec.assigneeComment = '';
    newRec.createdBy = currentFollowup.createdBy;
    newRec.creationDate = currentFollowup.creationDate;
    this.completingTask = true;
    await this.followupService.updateFollowup(newRec);
    let idx = this.plansArr.findIndex((a) => a.id == currentFollowup.id);
    this.plansArr.splice(idx, 1);
    await this.loadTasks();
    this.completingTask = false;
  }

  async CompleteTask(user: MemberSearch) {
    let newRec: UpdatePlannedFollowup = new UpdatePlannedFollowup();
    newRec.id = user['taskId'];
    newRec.memberId = user['memberId'];
    newRec.activity = user['activity'];
    newRec.planDate = user['planDate'];
    newRec.actualDate = user['actualDate'];
    newRec.status = user['status'];
    newRec.assigner = user['assigner'];
    newRec.assignerComment = user['assignerComment'];
    newRec.assignee = user['assignee'];
    newRec.assigneeComment = user['assigneeComment'];
    newRec.createdBy = user['createdBy'];
    newRec.creationDate = user['creationDate'];
    this.completingTask = true;
    await this.followupService.updateFollowup(newRec);
    let idx = this.plansArr.findIndex((a) => a.id == newRec.id);
    this.plansArr.splice(idx, 1);
    await this.loadTasks();
    this.completingTask = false;
  }

  ExpandFunctions(user: MemberSearch) {
    let status = user['expandFunctions'];
    var plan = this.plansArr.filter((a) => a.memberId == user.memberId)[0];
    user['activity'] = plan.activity;
    user['activityStr'] = plan.activityStr;
    user['assigner'] = plan.assigner;
    this.InitializeFunctionExpansion();
    user['expandFunctions'] = !status;
    if (user['expandFunctions'] == false) {
      user['confirmView'] = false;
      user['editView'] = false;
    }
    this.changeDetectorRef.detectChanges();
  }
}
